import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackMakeWishListPrivateParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/wishList/trackMakeWishListPrivate";

const useTrackMakeWishListPrivate = (
    parameters: TrackMakeWishListPrivateParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.makeWishListPrivate, parameters, options);
};

export default useTrackMakeWishListPrivate;
